import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  footerContainer: {
    display: 'flex',
    justifyContent: 'center',
    borderTop: '1px solid #ffcd57',
    color: 'white',
    padding: '32px 32px 96px 32px',
  },
}));

const FooterComponent: React.FC = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.footerContainer}>
      Copyright ©️ 2026 KIRKE | Photos by Jaakko Manninen
    </div>
  );
};

export default FooterComponent;
